import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useTranslation } from "../../context/TranslationContext";
import { useWebSocket } from '../../context/WebSocketContext';
import { useNavigate } from "react-router-dom";
import { ConnectionEventEmitter } from '../../utils/ConnectionEventEmitter';
import List from "../../components/List";
import ListItem from "../../components/ListItem";
import log from "loglevel";

import '../../styles/Host.css'; 

function HostAttractions() {
  const { t, language } = useTranslation();
  const { sendMessage, isConnected } = useWebSocket();
  const [state, setState] = useState(() => localStorage.getItem("attractions_state") || "list");
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("attractions_state", state);
  }, [state]);

  const list = {
    "elements": [
      {
        "id": 1,
        "name": {
          "pl": "Zamek Santa Bárbara",
          "en": "Santa Bárbara Castle",
          "de": "Burg Santa Bárbara"
        },
        "slogan": {
          "pl": "Średniowieczna twierdza z niesamowitymi widokami!",
          "en": "A medieval fortress with stunning views!",
          "de": "Eine mittelalterliche Festung mit atemberaubender Aussicht!"
        },
        "address": {
          "city": "Alicante",
          "street": "Calle Castillo de Santa Bárbara",
          "postalCode": "03002",
          "googleLink": "https://www.google.com/maps?q=38.3498,-0.4813",
          "latitude": 38.3498,
          "longitude": -0.4813,
          "text": "Calle Castillo de Santa Bárbara, 03002 Alicante, Spain"
        },
        "icon": "https://example.com/icons/castillo_icon.jpg",
        "images": [
          "https://example.com/images/castillo1.jpg",
          "https://example.com/images/castillo2.jpg",
          "https://example.com/images/castillo3.jpg"
        ],
        "description": {
          "pl": "<p>Zamek Santa Bárbara to jedno z najważniejszych miejsc w Alicante. Jego historia sięga IX wieku, a z murów rozpościera się panoramiczny widok na miasto i Morze Śródziemne.</p>",
          "en": "<p>Santa Bárbara Castle is one of the most important landmarks in Alicante. Its history dates back to the 9th century, and its walls offer a panoramic view of the city and the Mediterranean Sea.</p>",
          "de": "<p>Die Burg Santa Bárbara ist eines der wichtigsten Wahrzeichen von Alicante. Ihre Geschichte reicht bis ins 9. Jahrhundert zurück, und von ihren Mauern aus hat man einen Panoramablick auf die Stadt und das Mittelmeer.</p>"
        },
        "visitTime": {
          "pl": "Ok. 2-3 godziny",
          "en": "Approx. 2-3 hours",
          "de": "Ca. 2-3 Stunden"
        },
        "ticketInfo": {
          "pl": "Bilety można kupić na miejscu lub online na oficjalnej stronie zamku.",
          "en": "Tickets can be purchased on-site or online on the official castle website.",
          "de": "Tickets können vor Ort oder online auf der offiziellen Website der Burg gekauft werden."
        },
        "website": "https://www.castillodesantabarbara.com",
        "placeId": 101
      },
      {
        "id": 2,
        "name": {
          "pl": "Park Naturalny Peñón de Ifach",
          "en": "Peñón de Ifach Natural Park",
          "de": "Naturpark Peñón de Ifach"
        },
        "slogan": {
          "pl": "Ikoniczna skała wznosząca się nad morzem!",
          "en": "An iconic rock rising above the sea!",
          "de": "Ein ikonischer Felsen über dem Meer!"
        },
        "address": {
          "city": "Calpe",
          "street": "Av. de los Ejércitos Españoles",
          "postalCode": "03710",
          "googleLink": "https://www.google.com/maps?q=38.6442,0.0673",
          "latitude": 38.6442,
          "longitude": 0.0673,
          "text": "Av. de los Ejércitos Españoles, 03710 Calpe, Spain"
        },
        "icon": "https://example.com/icons/penon_icon.jpg",
        "images": [
          "https://example.com/images/penon1.jpg",
          "https://example.com/images/penon2.jpg",
          "https://example.com/images/penon3.jpg"
        ],
        "description": {
          "pl": "<p>Peñón de Ifach to 332-metrowa skała, która jest symbolem Costa Blanca. Można tu wspiąć się na szczyt i podziwiać spektakularne widoki na wybrzeże.</p>",
          "en": "<p>Peñón de Ifach is a 332-meter-high rock that serves as a symbol of Costa Blanca. You can hike to the top and enjoy spectacular views of the coastline.</p>",
          "de": "<p>Der Peñón de Ifach ist ein 332 Meter hoher Felsen, der als Symbol der Costa Blanca gilt. Man kann ihn besteigen und eine spektakuläre Aussicht auf die Küste genießen.</p>"
        },
        "visitTime": {
          "pl": "Ok. 3-4 godziny",
          "en": "Approx. 3-4 hours",
          "de": "Ca. 3-4 Stunden"
        },
        "ticketInfo": {
          "pl": "Wstęp bezpłatny, ale liczba miejsc jest ograniczona – warto zarezerwować online.",
          "en": "Entry is free, but spots are limited – it's worth booking online.",
          "de": "Der Eintritt ist frei, aber die Plätze sind begrenzt – es lohnt sich, online zu reservieren."
        },
        "website": "https://www.parquesnaturales.gva.es",
        "placeId": 102
      },
      {
        "id": 3,
        "name": {
          "pl": "Wyspy Tabarca",
          "en": "Tabarca Islands",
          "de": "Tabarca-Inseln"
        },
        "slogan": {
          "pl": "Najmniejsza zamieszkana wyspa Hiszpanii!",
          "en": "The smallest inhabited island in Spain!",
          "de": "Die kleinste bewohnte Insel Spaniens!"
        },
        "address": {
          "city": "Tabarca",
          "street": "Port de Santa Pola",
          "postalCode": "03130",
          "googleLink": "https://www.google.com/maps?q=38.1712,-0.4816",
          "latitude": 38.1712,
          "longitude": -0.4816,
          "text": "Port de Santa Pola, 03130 Santa Pola, Spain"
        },
        "icon": "https://example.com/icons/tabarca_icon.jpg",
        "images": [
          "https://example.com/images/tabarca1.jpg",
          "https://example.com/images/tabarca2.jpg",
          "https://example.com/images/tabarca3.jpg"
        ],
        "description": {
          "pl": "<p>Tabarca to malownicza wyspa znana z krystalicznie czystych wód i wspaniałych owoców morza. Jest doskonałym miejscem na jednodniową wycieczkę.</p>",
          "en": "<p>Tabarca is a picturesque island known for its crystal-clear waters and amazing seafood. It is a perfect destination for a day trip.</p>",
          "de": "<p>Tabarca ist eine malerische Insel, die für ihr kristallklares Wasser und großartiges Meeresfrüchteessen bekannt ist. Sie ist ein perfektes Ziel für einen Tagesausflug.</p>"
        },
        "visitTime": {
          "pl": "Cały dzień",
          "en": "Full day",
          "de": "Ganztägig"
        },
        "ticketInfo": {
          "pl": "Bilety na prom można kupić w porcie Santa Pola lub online.",
          "en": "Ferry tickets can be purchased at Santa Pola port or online.",
          "de": "Fährtickets können im Hafen von Santa Pola oder online gekauft werden."
        },
        "website": "https://www.islatabarca.com",
        "place_id": 103
      }
    ]
  }

  const listResponseCallback = useRef(null); 

  const halndeGenerate = (item) => {
    log.debug(item.aiDescription);

    setTimeout(() => {
      if (listResponseCallback.current) {
        listResponseCallback.current();
      }
    }, 500);
  };

  const screens = {
    "elements": [
      {
        "id": 5,
        "title": t.edit.Address,
        "showLanguage": false,
        "showIcon": true,
        "buttonLeft": t.general.Back,
        "buttonRight": t.general.Next,
        "focusAt": "",
        "fields": [
          {
            "id": "attraction_5_0",
            "fieldType": "inputAddress",
            "jsonId": "address",
            "hint": t.edit.AddressHint,
            "required": "city"
          },
          {
            "id": "attraction_5_1",
            "fieldType": "inputPlace",
            "jsonId": "place",
            "label": t.edit.Place,
            "hint": t.edit.PlaceHint,
            "required": true
          }
        ]
      },
      {
        "id": 0,
        "title": t.host.AttractionDescribe,
        "showLanguage": false,
        "showIcon": false,
        "buttonLeft": t.general.Cancel,
        "buttonRight": t.general.Generate,
        "onNext": halndeGenerate,
        "focusAt": "attraction_0_0",
        "fields": [
          {
            "id": "attraction_0_0",
            "fieldType": "inputDescription",
            "jsonId": "aiDescription",
            "required": true,
            "height": "100%",
            "hint": t.host.AttractionAI,
            "multilanguage": false,
            "minLength": 10,
            "maxLength": 2048
          }
        ]
      },
      {
        "id": 1,
        "title": t.host.Overview,
        "showLanguage": true,
        "showIcon": true,
        "buttonLeft": t.general.Back,
        "buttonRight": t.general.Next,
        "focusAt": "attraction_1_0",
        "fields": [
          {
            "id": "attraction_1_0",
            "fieldType": "inputText",
            "jsonId": "name",
            "label": t.edit.Name,
            "hint": t.edit.NameHint,
            "focusAt": "attraction_1_1",
            "multilanguage": true,
            "required": true,
            "minLength": 3,
            "maxLength": 50
          },
          {
            "id": "attraction_1_1",
            "fieldType": "inputText",
            "jsonId": "slogan",
            "label": t.edit.Slogan,
            "hint": t.edit.SloganHint,
            "multilanguage": true,
            "required": true,
            "minLength": 3,
            "maxLength": 50
          },
          {
            "id": "attraction_1_2",
            "fieldType": "inputDescription",
            "jsonId": "description",
            "label": t.edit.Description,
            "multilanguage": true,
            "required": true,
            "minLength": 30,
            "maxLength": 2048,
            "height": "100%"
          }
        ]
      },
      {
        "id": 2,
        "title": t.host.Gallery,
        "showLanguage": false,
        "showIcon": true,
        "buttonLeft": t.general.Back,
        "buttonRight": t.general.Next,
        "focusAt": "attraction_2_0",
        "fields": [
          {
            "id": "attraction_2_0",
            "fieldType": "inputGallery",
            "max": 10,
            "jsonId": "images",
            "required": 1
          }
        ]
      },
      {
        "id": 3,
        "title": t.edit.DescriptionAdd,
        "showLanguage": true,
        "showIcon": true,
        "buttonLeft": t.general.Back,
        "buttonRight": t.general.Next,
        "focusAt": "attraction_3_0",
        "fields": [
          {
            "id": "attraction_3_0",
            "fieldType": "inputDescription",
            "jsonId": "description",
            "label": t.edit.Description,
            "multilanguage": true,
            "required": true,
            "minLength": 30,
            "maxLength": 2048
          }
        ]
      },
      {
        "id": 4,
        "title": t.edit.DetailsAdd,
        "showLanguage": true,
        "showIcon": true,
        "buttonLeft": t.general.Back,
        "buttonRight": t.general.Preview,
        "focusAt": "attraction_4_0",
        "fields": [
          {
            "id": "attraction_4_0",
            "fieldType": "inputText",
            "jsonId": "visitTime",
            "label": t.edit.VisitTime,
            "hint": t.edit.VisitTimeHint,
            "multilanguage": true,
            "required": false,
            "minLength": 3,
            "maxLength": 50
          },
          {
            "id": "attraction_4_1",
            "fieldType": "inputText",
            "jsonId": "ticketInfo",
            "label": t.edit.TicketsBuy,
            "hint": t.edit.TicketsBuyHint,
            "multilanguage": true,
            "required": false,
            "minLength": 3,
            "maxLength": 50
          },
          {
            "id": "attraction_4_2",
            "fieldType": "inputWebsite",
            "jsonId": "website",
            "label": t.edit.Website,
            "hint": t.edit.WebsiteHint,
            "required": false,
            "minLength": 3,
            "maxLength": 50
          },
          {
            "id": "attraction_4_3",
            "fieldType": "inputSelect",
            "jsonId": "placeId",
            "label": t.edit.Places,
            "hint": t.edit.PlacesHint,
            "required": false
          }
        ]
      }
    ]
  }


  const connectionOpened = useCallback(() => {
    log.debug('Attractions connectionOpened');
  }, []);

  const connectionClosed = useCallback(() => {
    log.debug('Attractions connectionClosed');
  }, []);

  const connectionReceived = useCallback((receivedMessage) => {
    if(receivedMessage) {
      log.debug('Attractions received message:', receivedMessage);
    }
  }, []);

  const handleBack = () => {
    navigate('/host'); 
  };

  const handleAdd = () => {
    setState("add");
  };

  const handleAddCancel = () => {
    setState("list");
  };

  const handleAddFinish = (item) => {
    setState("list");
  };
  const getLabel = (item,viewLanguage) => {
    return item.name[viewLanguage] ? item.name[viewLanguage] : "";
  };

  const getDescription = (item,viewLanguage) => {
    var r = item.address.city ? item.address.city + " - " : "";
    if(item.slogan[viewLanguage]!==undefined) {
      r += item.slogan[viewLanguage];
    }
    return r
  };

  useEffect(() => {    
    ConnectionEventEmitter.on('opened', connectionOpened);
    ConnectionEventEmitter.on('closed', connectionClosed);
    ConnectionEventEmitter.on('received', connectionReceived);
    return () => { 
      ConnectionEventEmitter.off('opened', connectionOpened);
      ConnectionEventEmitter.off('closed', connectionClosed);
      ConnectionEventEmitter.off('received', connectionReceived);
    }
  }, []);

  const contentMap = {
    list: (
      <List list={list} id="attractions" title={t.host.Attractions} onBack={handleBack} onAdd={handleAdd} getLabel={getLabel} getDescription={getDescription}></List>
    ),
    add: (
      <ListItem screens={screens} id="attractions" onResponse={(callback) => (listResponseCallback.current = callback)} onCancel={handleAddCancel} onFinish={handleAddFinish} finishLabel={t.general.Preview} getLabel={getLabel} getDescription={getDescription}></ListItem>
    )
  };

  return (
    <>{(contentMap[state])}</>
  );
}

export default HostAttractions;